import { 
  getWebhookConnectionByCustomerId, 
  upsertWebhookConnection, 
  deleteWebhookConnection,
  updateWebhookFilterMode 
} from '../../service/UserService';
import { getheaders } from '../../service/authService';

// Re-export the functions from UserService
export { 
  getWebhookConnectionByCustomerId, 
  upsertWebhookConnection, 
  deleteWebhookConnection,
  updateWebhookFilterMode 
};

// Fetch reservations from Guesty API
export const fetchGuestyReservations = async (guestyClientId) => {
  try {
    const response = await fetch(`/api/guesty/reservations/fetch/${guestyClientId}`, {
      method: 'GET',
      headers: getheaders(),
      redirect: 'follow'
    });
    
    return response;
  } catch (error) {
    console.error('Error fetching reservations:', error);
    throw error;
  }
};

// Update a single reservation
export const updateGuestyReservation = async (reservationId) => {
  try {
    const response = await fetch(`/api/guesty/reservations/update/${reservationId}`, {
      method: 'GET',
      headers: getheaders(),
      redirect: 'follow'
    });
    
    return response;
  } catch (error) {
    console.error('Error updating reservation:', error);
    throw error;
  }
};

// Parse API response
export const parseApiResponse = async (response) => {
  if (response.status === 200) {
    const result = await response.json();
    return { success: true, data: result };
  } else {
    try {
      const text = await response.text();
      try {
        // Try to parse the error response as JSON
        const errorData = JSON.parse(text);
        return { 
          success: false, 
          error: errorData.message || "API request failed" 
        };
      } catch (e) {
        // If parsing fails, use the raw text
        return { 
          success: false, 
          error: text || "API request failed" 
        };
      }
    } catch (error) {
      return { 
        success: false, 
        error: "An error occurred while processing the response" 
      };
    }
  }
};
